import { api } from './api';
import type { PassportProvenanceMetadata } from './passportProvenance';

/** Same authenticated save path. Optional evidence is validated by the BFF;
 * forwarding remains blocked until the Hub accepts a published metadata DTO. */
export function submitStep(
  id: string | number,
  stepKey: string,
  responses: unknown,
  provenance?: PassportProvenanceMetadata | null,
) {
  return api<any>(`/applications/${id}/steps/${encodeURIComponent(stepKey)}/submit`, {
    method: 'POST',
    body: JSON.stringify(provenance ? { responses, provenance } : { responses }),
  });
}